<div class="container" [ngClass]="{ readonly: ReadOnly == true }">
    <div class="row container-fluid member-info-search" style="padding-top:0.3rem;">
        <div class="row memberinfo">Member Information</div>
        <div class="row memberinfomsg">Please select one of the required fields below</div>
        <div class="search-field-container">
          <!-- <form> -->
            <div class="row">
                <div class="col-3 disp-grid">
                    <label class="search-field-label">Carrier Member ID</label>
                    <input type="text" name="carrier" class="search-field" [(ngModel)]="memberSearchData.CarrierMemberId">
                </div>
                <div class="col-3 disp-grid">
                    <label class="search-field-label">Name</label>
                    <input type="text" name="name" class="search-field" [(ngModel)]="memberSearchData.Name"/>
                </div>
                <div class="col"></div>
            </div>
            <div class="row">
                <div class="col-3 disp-grid">
                    <label class="search-field-label">Email</label>
                    <input type="email" name="email" class="search-field" [(ngModel)]="memberSearchData.Email">
                </div>
                <div class="col-3 disp-grid">
                    <label class="search-field-label">Date of Birth</label>
                    <p-calendar class="calender"
                    name="dob"
                        [readonlyInput]="true"
                        [(ngModel)]="memberSearchData.DateOfBirth"
                        [iconDisplay]="'input'" 
                        [showIcon]="true" 
                        [maxDate]="maxdate"
                        placeholder="MM/DD/YYYY"
                        inputId="icondisplay" 
                        />
                </div>
                <div class="col"></div>
            </div>
            <div class="row" style="padding-top:0.2rem;">
                <div class="col-1 col-serach">
                    <button class="btn-search" (click)="search()">Search</button>
                    <!-- <input class="btn-search" type="submit" value="Search" (click)="search()"> -->
                </div>
                <div class="col">
                    <button class="clear-search" (click)="clearSearchResults()">Clear Search Results</button>
                </div>
            </div>
          <!-- </form> -->
        </div>
    </div>
    <div class="row container-fluid member-information" *ngIf="showTabularData">
      <hr class="light-separator" />
      <label class="recordcount">{{MemberData?MemberData.length:0}} Records Found</label>
      <p-table [value]="MemberData" [tableStyle]="{ 'min-width': '50rem' }"
      [(first)]="currentpage"
      [paginator]="true"
      [rows]="5"
      [totalRecords]="MemberData?.length"
      (onRowSelect)="onRowSelect($event)"
      selectionMode="single"
      [scrollable]="true"
      (onPage)="onPageChange($event)"
      >
          <ng-template pTemplate="header">
              <tr>
                  <th>Member ID</th>
                  <th>Name
                    <span class="sort" (click)="sortByName()">
                      <ng-container *ngIf="sortOrder; else others">
                        <ng-container *ngIf="sortOrder=='Asc'; else falseBlock">
                          <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                        </ng-container>
                        <ng-template #falseBlock>
                          <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                        </ng-template>
                      </ng-container>
    
                      <ng-template #others>
                        <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                      </ng-template>
                    </span>
                  </th>
                  <th>Email</th>
                  <th>Address</th>
                  <th>Address2</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip</th>
                  <th>Date of Birth</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-memberInfo>
              <tr [pSelectableRow]="memberInfo">
                  <td> {{memberInfo['MemberId']}}</td>
                  <td>{{memberInfo['Name']}} </td>
                  <td>{{memberInfo['Email']}} </td>
                  <td>{{memberInfo['Address']}} </td>
                  <td>{{memberInfo['Address2']}} </td>
                  <td>{{memberInfo['City']}} </td>
                  <td>{{memberInfo['State']}} </td>
                  <td>{{memberInfo['Zip']}} </td>
                  <td>{{memberInfo['DateOfBirth']}} </td>
              </tr>
          </ng-template>
      </p-table>

    </div>
    <div class="row container-fluid member-information" *ngIf="displayMemberInfo">
      <hr class="light-separator" />
      <a (click)="navBack()" class="navCont navback" *ngIf="this.MemberData?.length>1"><pre class="navback arrow" >< </pre>Back</a>
      <label class="lbl-member">{{MemberName?MemberName:''}}</label>
      <hr class="separator" />
      <!-- <form [formGroup]="dynamicForm" *ngIf="FieldsConf.Groups.length > 0"> -->
        <div class="data-container">
          <div class="input-data" *ngFor="let kv of mappedDetails | keyvalue">
              <label class="info-label" for="{{ kv.key }}">{{ kv.key }}</label><br />
              <label class="info-value" for="{{ kv.value }}">{{ kv.value || '-'}}</label><br />
          </div> 
        </div>
      <!-- </form> -->
    </div>
  </div>